// extracted by mini-css-extract-plugin
export default {"card":"S3-z"};